import { useEffect, useState } from 'react';

const useLoadTransition = (isLoading, exitDelay = 320) => {
  const [showLoader, setShowLoader] = useState(Boolean(isLoading));
  const [isContentVisible, setIsContentVisible] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setShowLoader(true);
      setIsContentVisible(false);
      return undefined;
    }

    setIsContentVisible(true);
    const timeout = window.setTimeout(() => setShowLoader(false), exitDelay);

    return () => {
      window.clearTimeout(timeout);
    };
  }, [exitDelay, isLoading]);

  return { showLoader, isContentVisible };
};

export default useLoadTransition;
